import { Subscription } from 'rxjs';

import { AlertTypesEnum } from '../enums';
import { AlertTimeOut } from '../components/alert/alert.component';

export class Alert {
  public subscription: Subscription | undefined;

  public index: number;
  public type: AlertTypesEnum;
  public message: string;
  public isAutoRemovable: boolean;
  public timeOut: number;

  constructor(
    index: number,
    type: AlertTypesEnum,
    message: string,
    isAutoRemovable: boolean,
    timeOut?: number
  ) {
    this.index = index;
    this.type = type;
    this.message = message;
    this.isAutoRemovable = isAutoRemovable;
    this.timeOut = !timeOut ? AlertTimeOut : timeOut;
  }
}
